import React, { useState, useEffect } from 'react';
import { Grid, Button, FormControl, FormLabel, FormControlLabel, FormGroup, Checkbox, Collapse, Icon, Box } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';
import { get, set } from 'global/lib/lodash';
import { useScreen } from 'global/styles';
import { FilterRow, filterFormGridSx, filterFormItemSx, filterIconSx, filterCheckRowSx, filterCheckIconSx, filterHiddenSx } from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';
import { cleanCopy } from 'global/utils';

export default function PerformLibraryFilters({ config, onChange, renderFilterChips }) {
  const [showFilters, setShowFilters] = useState(false);
  const [closed, setClosed] = useState({});

  const { isMobile } = useScreen();

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  const onFilterChange = (parent, child, event) => {
    const conf = cleanCopy(config);
    const location = [parent, 'data', child, 'value'];
    const currentValue = get(config, location);
    set(conf, location, !currentValue);
    onChange(conf);
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  function clearFilters() {
    const conf = cleanCopy(config);
    Object.keys(conf).forEach((parent) => {
      Object.keys(get(conf, [parent, 'data'], {})).forEach((child) => {
        set(conf, [parent, 'data', child, 'value'], false);
      });
    });
    onChange(conf);
  }

  const toggleClosed = (conf) => {
    setClosed({
      ...closed,
      [conf.title]: !get(closed, conf.title, true),
    });
  };

  return (
    <div>
      {isMobile && (
        <FilterRow isMobile>
          <Button aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" sx={filterIconSx} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
          {renderFilterChips && renderFilterChips()}
        </FilterRow>
      )}

      <DiagContainer useDialog={isMobile} title="Filters" onClose={toggleFilters} onClear={clearFilters} open={showFilters}>
        <form autoComplete="off" margin="normal" style={!showFilters ? filterHiddenSx : undefined}>
          <Grid container>
            {Object.keys(config).map((k, index) => {
              const conf = config[k];
              const data = get(conf, 'data', {});
              const open = get(closed, conf.title, true);
              const show = get(conf, 'canShow', () => true)(conf);

              return !show ? null : (
                <Grid item key={index} xs={12} sx={filterFormGridSx}>
                  <FormControl component="fieldset" sx={filterFormItemSx}>
                    <FormLabel style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => toggleClosed(conf)} component="legend">
                      {conf.title}
                      <Icon>{open ? 'arrow_drop_down' : 'arrow_right'}</Icon>
                    </FormLabel>
                    <Collapse in={open}>
                      <FormGroup>
                        {Object.keys(data).map((dk) => {
                          const item = get(data, dk, {});
                          const val = get(data, [dk, 'value'], 0);
                          return (
                            <FormControlLabel
                              key={dk}
                              control={<Checkbox checked={!!val} onChange={(e) => onFilterChange(k, dk, e)} value={val} />}
                              label={
                                <Box sx={filterCheckRowSx}>
                                  {item.icon && <Box sx={filterCheckIconSx}>{item.icon}</Box>}
                                  {item.name}
                                </Box>
                              }
                            />
                          );
                        })}
                      </FormGroup>
                    </Collapse>
                  </FormControl>
                </Grid>
              );
            })}
          </Grid>
        </form>
      </DiagContainer>
    </div>
  );
}
